/* eslint-disable no-restricted-imports */
import { AddLiquidity } from './actions/addLiquidity';
import { CreateLock } from './actions/createLock';
import { ExchangeOnPool } from './actions/exchangeOnPool';
import { IncreaseAmount } from './actions/increaseAmount';
import { IncreaseUnlockTime } from './actions/increaseUnlockTime';
import { RemoveLiquidityOneCoin } from './actions/removeLiquidityOneCoin';
import { Stake } from './actions/stake';
import { Unstake } from './actions/unstake';
import { Withdraw } from './actions/withdraw';
import { CalculateTokenAmount } from './getters/calculateTokenAmount';
import { GetBestRate } from './getters/getBestRate';
import { GetExchangeAmount } from './getters/getExchangeAmount';
import { Locked } from './getters/locked';
import { CalculateWithdrawOneCoin } from './getters/calculateWithdrawOneCoin';
import { ClaimRewards } from './actions/claimRewards';
import { ClaimableReward } from './getters/claimableReward';
var actions = {
    AddLiquidity: AddLiquidity,
    RemoveLiquidityOneCoin: RemoveLiquidityOneCoin,
    Stake: Stake,
    Unstake: Unstake,
    CreateLock: CreateLock,
    IncreaseAmount: IncreaseAmount,
    IncreaseUnlockTime: IncreaseUnlockTime,
    Withdraw: Withdraw,
    ExchangeOnPool: ExchangeOnPool,
    ClaimRewards: ClaimRewards,
};
var getters = {
    GetExchangeAmount: GetExchangeAmount,
    CalculateTokenAmount: CalculateTokenAmount,
    CalculateWithdrawOneCoin: CalculateWithdrawOneCoin,
    GetBestRate: GetBestRate,
    Locked: Locked,
    ClaimableReward: ClaimableReward,
};
var Curve = { actions: actions, getters: getters };
export { Curve };
